var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rate-amount"},[(_vm.amount_points)?_c('rate-points',{attrs:{"amount_points":_vm.amount_points,"rate_only":_vm.rate_only}}):_c('rate-pricing',{attrs:{"pricing":_vm.pricing,"rate_only":_vm.rate_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }